import { showLocalDate } from "../../../utilities/functions";

const StartDate = ({ row }) => {
  return <div>{row.startDate ? showLocalDate(row?.startDate) : ""}</div>;
};

export default StartDate;
